@if (shouldDisplayHint$ | async) {
  <ngb-alert class="mt-3" type="important" [dismissible]="false">
    <div class="d-flex align-items-center">
      <div>
        <svg class="icon icon-18 mr-3">
          <use xlink:href="/assets/img/svgs/svgset.svg#alert-danger" />
        </svg>
      </div>
      <div>
        <span class="font-size-smaller1" [innerHTML]="'mydepot.trading.secure-tan-hint.text' | transloco"></span>
        <a
          class="link-secondary font-size-smaller1"
          target="_blank"
          rel="noreferrer noopener"
          href="https://www.finanzen.net/zero/securetan"
        >
          (iOS/Android)
        </a>
      </div>
    </div>
  </ngb-alert>
}
